import { render, staticRenderFns } from "./paging.vue?vue&type=template&id=6fe98762&scoped=true&"
import script from "./paging.vue?vue&type=script&lang=js&"
export * from "./paging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe98762",
  null
  
)

export default component.exports